// extracted by mini-css-extract-plugin
export var link = "_rk-0";